import styled from "styled-components"
import { MobergAnimationCurve, MobergAnimationTiming, MobergFontFamily, MobergTheme } from "../../Moberg"
import React, { CSSProperties, MouseEvent } from "react"

type MobergHoverRowProps = {
    theme: MobergTheme
    active: boolean
	onClick?: (event: MouseEvent<any>) => void
	style?: CSSProperties
}

type StyledRowProps = {
	isBlue: boolean
	active: boolean
}

const BLUE_THEMES = new Set([MobergTheme.BLUE, MobergTheme.ON_LIGHT_BLUE])

export const MobergHoverRow: React.FC<MobergHoverRowProps> = ({ theme, active, children, onClick, style }) => {
    return (
        <StyledRow isBlue={BLUE_THEMES.has(theme)} active={active} style={style} onMouseDown={onClick}>
            {children}
        </StyledRow>
    )
}

const StyledRow = styled.div<StyledRowProps>`
	display: flex;
	align-items: center;
	font-family: ${MobergFontFamily.REGULAR};
	font-weight: bold;
	border-radius: 4px;
	cursor: pointer;
	justify-content: space-between;
    padding: 0 16px;
	padding-right: 8px;
	color: ${({ active, isBlue }) =>
		active && isBlue
			? "var(--color-hover-active-blue-text, var(--text-color))"
			: "var(--text-color)"};
	transition: background-color ${MobergAnimationTiming.VERY_FAST} ${MobergAnimationCurve.EASE_IN};

	background-color: ${({ active, isBlue }) =>
		active
			? isBlue ? "var(--color-hover-active-blue)" : "var(--color-hover-active-neutral)"
			: "unset"};

	&:hover {
		background-color: ${({ active, isBlue }) =>
			active
				? isBlue ? "var(--color-hover-active-blue)" : "var(--color-hover-active-neutral)"
				: isBlue ? "var(--color-hover-blue)" : "var(--color-hover-neutral)"};
		color: ${({ active, isBlue }) =>
			active && isBlue
				? "var(--color-hover-active-blue-text, var(--text-color))"
				: "var(--text-color)"};
	}
`